/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

@Directive({
    selector: '[appHAProxyTimeValidator]',
    providers: [{ provide: NG_VALIDATORS, useExisting: HaProxyTimeValidationDirective, multi: true }]
})

export class HaProxyTimeValidationDirective implements Validator {
    public validate(control: AbstractControl): { [key: string]: any } | null {
        return haproxyTimeValidation(control);
    }
}

/**
 * Validate haproxy time. So check to see if the integer has the
 * right si notation.
 * @param control
 * @returns {any}
 */
export function haproxyTimeValidation(control: any): any {
    const haproxySplit: any[] = control?.value?.match(/[a-z]+|[^a-z]+/gi);

    return (
        !control?.value ||
        (
            haproxySplit?.length === 2 ? ( // two parts only: [number, unit]
                Math.sign(haproxySplit[0]) > 0 && // test for positive number (anything else is false)
                ['us', 'ms', 's', 'm', 'h', 'd'].includes(haproxySplit[1]) // check unit is valid
            ) : false
        )
    ) ? null : { 'haproxyTimeValidation': 'invalid_time_unit' };

}
